import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

export default function CtaBanner() {
  const { t } = useLang();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="cta-banner"
      className="py-24 md:py-28"
      style={{
        background:
          "linear-gradient(180deg, #ffffff 0%, #ffffff 50%, var(--sap-gray-50) 50%, var(--sap-gray-50) 100%)",
      }}
    >
      <div className="sap-container">
        <Reveal>
          <div
            className="relative overflow-hidden p-10 md:p-16"
            style={{ background: "var(--sap-navy)" }}
          >
            <div
              aria-hidden
              className="absolute inset-0 opacity-30"
              style={{
                backgroundImage:
                  "linear-gradient(to right, rgba(197,160,89,0.15) 1px, transparent 1px), linear-gradient(to bottom, rgba(197,160,89,0.15) 1px, transparent 1px)",
                backgroundSize: "60px 60px",
                maskImage:
                  "radial-gradient(ellipse at right, rgba(0,0,0,0.6), transparent 70%)",
              }}
            />
            <div className="relative grid lg:grid-cols-12 gap-10 items-center">
              <div className="lg:col-span-8">
                <div className="flex items-center gap-3 mb-6">
                  <span className="sap-divider-gold" />
                  <span
                    className="text-[11px] uppercase tracking-[0.3em]"
                    style={{ color: "var(--sap-gold)" }}
                  >
                    {t.cta_final.overline}
                  </span>
                </div>
                <h2
                  className="font-serif text-white leading-[1.1] tracking-tight"
                  style={{ fontSize: "clamp(1.9rem, 3.6vw, 3rem)", fontWeight: 400 }}
                >
                  {t.cta_final.title}
                </h2>
                <p className="mt-6 text-white/75 text-base md:text-lg max-w-2xl">
                  {t.cta_final.subtitle}
                </p>
              </div>
              <div className="lg:col-span-4 flex lg:justify-end">
                <button
                  type="button"
                  data-testid="cta-banner-button"
                  onClick={() => scrollTo("diagnostic")}
                  className="sap-btn-primary"
                  style={{
                    background: "var(--sap-gold)",
                    borderColor: "var(--sap-gold)",
                  }}
                >
                  {t.cta_final.button}
                  <ArrowRight size={16} strokeWidth={1.75} />
                </button>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
